import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_238: DocMigration = {
  maxSchemaVersion: "0.0.238",
  description: "Fixes a bug with default option id for newly created option sets",
  apply(json: any) {
    if (json.optionSets) {
      for (const optionSetId in json.optionSets) {
        const optionSet = json.optionSets[optionSetId];

        // fix the id
        for (const key in optionSet.options) {
          const option = optionSet.options[key];
          if (key === "Option 2" && option.id === "Option 1") {
            option.id = key;
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_238;
